import axiosInstance from 'Shared/utilities/axiosInstance';
import {ProducerCompliancePolicyAttachmentsApi} from 'Agent/AgentInformation/api/api';
import {getAxiosConfig, handleResponse} from 'Shared/utilities/fetchHelpers';
import {ProducerCompliancePolicyAttachment} from 'Agent/AgentInformation/models/ProducerCompliancePolicyAttachment';
import {AsyncResult} from 'Core/models/Async';

const producerCompliancePolicyAttachmentApi = new ProducerCompliancePolicyAttachmentsApi(
  undefined,
  process.env.REACT_APP_BASE_GATEWAY_URL,
  axiosInstance
);

export const getProducerCompliancePolicyAttachments = (
  encryptedIdentifier: string
): Promise<AsyncResult<ProducerCompliancePolicyAttachment[]>> =>
  producerCompliancePolicyAttachmentApi
    .producerCompliancePolicyAttachmentsGet('1', {params: {encryptedIdentifier}, ...getAxiosConfig()})
    .then(handleResponse);
